import React from 'react';
import { Button, Tag } from 'antd';
import { DownOutlined, GroupOutlined, RightOutlined, UserOutlined } from '@ant-design/icons';
import { specialistCountLabel } from './assistantTableRows';
import { AssistantDropLabel } from './AssistantRowDnd';

export default function AssistantNameCell({
  record,
  icon,
  activeTab,
  groupsMap,
  onToggle,
  dragHandle,
}) {
  const chevronLabel = record.expanded ? 'Collapse specialists' : 'Expand specialists';
  return (
    <div className={`collection-name-cell${record.depth ? ' assistant-member-name' : ''}`}>
      {dragHandle}
      {record.rowKind === 'router' && (
        <Button
          type="text"
          size="small"
          className="assistant-group-chevron"
          aria-expanded={record.expanded}
          aria-label={chevronLabel}
          disabled={record.chevronDisabled}
          icon={record.expanded ? <DownOutlined /> : <RightOutlined />}
          onClick={(event) => {
            event.stopPropagation();
            if (!record.chevronDisabled) onToggle(record.id);
          }}
        />
      )}
      {icon}
      <div className="collection-name-text">
        <div className="collection-name-row">
          <span className="collection-name-label">{record.name}</span>
          {record.router_mode && <Tag style={{ marginLeft: 4, flexShrink: 0 }}>Routes</Tag>}
          {record.rowKind === 'router' && (
            <span className="assistant-specialist-count">{specialistCountLabel(record.specialistCount)}</span>
          )}
          {(activeTab === 'platform' || activeTab === 'group') && record.group_id && (
            <Tag color="purple" style={{ marginLeft: 4, flexShrink: 0 }} icon={<GroupOutlined />}>
              {groupsMap[record.group_id] || 'Group'}
            </Tag>
          )}
          {activeTab === 'platform' && !record.group_id && (
            <Tag color="blue" style={{ marginLeft: 4, flexShrink: 0 }} icon={<UserOutlined />}>
              Personal
            </Tag>
          )}
          <AssistantDropLabel record={record} />
        </div>
        {record.description ? <div className="collection-desc-label">{record.description}</div> : null}
        {record.alsoIn?.length > 0 && (
          <div className="collection-desc-label">Also in {record.alsoIn.join(', ')}</div>
        )}
      </div>
    </div>
  );
}
